<h1> Course Forum</h1>
@if (isOffline) {
  <div class="p-4">
    <ebs-offline-message [isOffline]="isOffline" [offlineMessage]="forumOfflineMessage"></ebs-offline-message>
  </div>
}

@if (checkingUserDetails) {
  <ebs-spinner [spinnerMessage]="'loading....'"></ebs-spinner>
}
@if (isEditModeAndIsNotAdmin() && !checkingUserDetails) {
  <div>
    <ebs-message-simple [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle fa-lg'" [textCssClasses]="'text-info'"
      [displayMessage]="'You do not have permission to perform this action'" [displayOnRight]="false">
    </ebs-message-simple>
  </div>
}
@if ((!isEditModeAndIsNotAdmin() && !loading && !isOffline)) {
  <div class="card">
    <div class="card-body">
      <h2 class="ml-3">
        @if (formMode != 'edit') {
          <span>
          Create new</span>
        }
        @if (formMode === 'edit') {
          <span>
          Update</span>
        }
        topic
      </h2>
      @if (showUserError) {
        <ebs-message-simple [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle fa-lg'"
          [textCssClasses]="'text-info'" [displayMessage]="'Unable to retrieve user details'" [displayOnRight]="false"
          >
        </ebs-message-simple>
      }
      @if (showIdError) {
        <ebs-message-simple [displayMessage]="noDiscussionIdMessage" [displayOnRight]="true">
        </ebs-message-simple>
      }
      @if (loading) {
        <ebs-spinner [spinnerMessage]="'loading....'"></ebs-spinner>
      }
      @if (!loading && !loadingDiscussion) {
        <div>
      <form class="form-group" [formGroup]="discussionForm" (ngSubmit)="submitForm()" style="margin-bottom: 20px;border-radius: 6px;
        padding: 1rem;">
            <label>
              Title:
            </label>
            <label>
              <input (change)="changed($event)" (keyup)="keyPressed($event)" class="form-control" type="text" formControlName="title">
              @if (discussionForm.controls.title.invalid && (discussionForm.controls.title.dirty || discussionForm.controls.title.touched)) {
                <div
                  class="alert alert-danger">
                  @if (discussionForm.controls.title.errors.required) {
                    <div> Title is required. </div>
                  }
                  @if (discussionForm.controls.title.errors.maxlength) {
                    <div> Title must be {{titleCharacterLimit}}
                      characters or less.
                    </div>
                  }
                </div>
              }
            </label>
            @if (itemsFound) {
              <div>
                <p></p>
                <i class="text-info fa fa-fw fa-exclamation-circle ng-star-inserted" ng-reflect-ng-class="text-info fa fa-fw fa-exclamat"></i>
                <span class="text-info ng-star-inserted">We found the following forum search results that might be related to your topic</span>
              </div>
            }
            @if (formMode != 'edit') {
              <ebs-forum-search (itemsFoundEvent)="setItemsFound($event)" [hideInput]="hideInput" [topicSearchText] = "currentSearchText" [courseCode]="courseCode"></ebs-forum-search>
            }
            <label class="mb-3">
              Description:
              <editor [init]="editorConfig" formControlName="description"></editor>
              @if (discussionForm.controls.description.invalid && (discussionForm.controls.description.dirty || discussionForm.controls.description.touched)) {
                <div
                  class="alert alert-danger">
                  @if (discussionForm.controls.description.errors.required) {
                    <div> Description is required. </div>
                  }
                  @if (discussionForm.controls.description.errors.maxlength) {
                    <div> Description must be
                    {{descriptionCharacterLimit}} characters or less.</div>
                  }
                </div>
              }
            </label>
            <ebs-tags [tagsMarkedAsActive]="initialTags" [courseCode]="courseCode" (tagsToSave)="updateTagsToSave($event)"
            [canAddTag]='isAnAdmin'></ebs-tags>
            @if (!areTagsExist()) {
              <ebs-message-simple [displayMessage]="noTag" [displayOnRight]="true" [textCssClasses]="'text-warning'"
                [iconCssClasses]="'text-warning fa fa-fw fa-exclamation-circle'">
              </ebs-message-simple>
            }
            <!--faculty fav-->
            @if (isAnAdmin) {
              <div class="d-flex flex-row-reverse mt-3 faculty-fav">
                <label class="switch float-right ml-2 mr-3 mt-2">
                  <input type="checkbox" [checked]="facultyFavourite" (click)="switchFacultyFav()">
                  <span class="slider round"></span>
                </label>
                <p>Pin as a Faculty Favourite</p>
              </div>
            }
            <div class="row mt-2">
              <div class="col-6">
                <a class="btn btn-outline-secondary btn-block" [routerLink]="listLink">Cancel</a>
              </div>
              <div class="col-6">
                @if (!creatingDiscussion) {
                  <button id="submit-button" class="btn btn-primary btn-block" type="submit"
                    [disabled]="!discussionForm.valid || !areTagsExist()">
                    @if (formMode != 'edit') {
                      <span class="d-none d-xl-block"> Create Topic</span>
                      <span class="d-xl-none"> Create</span>
                    } @else {
                      <span class="d-none d-xl-block"> Update Topic</span>
                      <span class="d-xl-none"> Update</span>
                    }
                  </button>
                }
                @if (showError) {
                  <ebs-message-simple [displayMessage]="errorMessage"></ebs-message-simple>
                }
                @if (creatingDiscussion) {
                  <ebs-spinner [spinnerMessage]="'processing..'"></ebs-spinner>
                }
              </div>
              <div class="col-12">
                <span class="pt-2 float-right gdpr-message" tooltip="{{gdprMessage}}" containerClass="customTooltip">
                  <ebs-message-simple [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle fa-lg'"
                    [textCssClasses]="'text-info'" [displayMessage]="displayMessage" [displayOnRight]="false">
                  </ebs-message-simple>
                </span>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
}